export const RECRUITMENT_MANAGE_WORKERS_ROLE = 'recruitment-manage-workers';
